import React from "react";
import D01 from "../Photo/D01";
export default function PhotoMain({ data }) {
  return (
    <div>
      {data?.advanceData?.design === "D01_L01" ? (
        <D01 photoItem={data}></D01>
      ) : (
        <D01 photoItem={data}></D01>
      )}
    </div>
  );
}
